import { FaCertificate, FaFileContract } from "react-icons/fa";
import { BsFillCalendar2WeekFill } from "react-icons/bs";
import { AiOutlineAudit } from "react-icons/ai";
import { GrCertificate } from "react-icons/gr";
import { TbCertificate2 } from "react-icons/tb";
import {
  HomeIcon,
  FarmerIcon,
  InventoryIcon,
  ProcurementIcon,
  ProfileIcon,
  CertificateIcon,
  StockIcon,
} from "./assets/svgs/Icons";

//Menu Items
const menuItems = [
  {
    id: 1,
    text: "Home",
    path: "/dashboard",
    icon: (
      <HomeIcon
        // _h={{ "> path": { fill: "white" } }}
        w={"30px"}
        h={"30px"}
      />
    ),
    visibleTo: ["GINNER", "NONGINNER"],
  },
  {
    id: 2,
    text: "Supplier",
    path: "/supplier",
    icon: (
      <FarmerIcon
        // _active={{ "> path": { fill: "white" } }}
        w={"30px"}
        h={"30px"}
      />
    ),
    // visibleTo: ["CLIENT", "GINNER"],
    visibleTo: ["CLIENT"],
  },
  {
    id: 3,
    text: "Inventory",
    path: "/inventory",
    icon: (
      <InventoryIcon
        // _active={{ "> path": { fill: "white" } }}
        w={"30px"}
        h={"30px"}
      />
    ),
    visibleTo: ["GINNER", "NONGINNER"],
  },
  {
    id: 4,
    text: "Procurement",
    path: "/procurement",
    icon: (
      <ProcurementIcon
        // _active={{ "> path": { fill: "white" } }}
        w={"30px"}
        h={"30px"}
      />
    ),
    // visibleTo: ["CLIENT", "GINNER"],
    visibleTo: ["CLIENT"],
  },
  {
    id: 5,
    text: "Transaction Certificates",
    path: "/client/transaction-certificates",
    icon: (
      <CertificateIcon
        // _active={{ "> path": { fill: "white" } }}
        w={"30px"}
        h={"30px"}
      />
    ),
    visibleTo: ["GINNER", "NONGINNER"],
  },

  {
    id: 6,
    text: "Profile",
    path: "/profile",
    icon: (
      <ProfileIcon
        // _active={{ "> path": { fill: "white" } }}
        w={"30px"}
        h={"30px"}
      />
    ),
    visibleTo: ["GINNER", "NONGINNER"],
  },

  {
    id: 7,
    text: "TC L1 Admin",
    path: "/tc-l1-admin",
    icon: (
      <ProfileIcon
        // _active={{ "> path": { fill: "white" } }}
        w={"30px"}
        h={"30px"}
      />
    ),
    visibleTo: ["ADMIN", "L1-TC-ISSUER"],
  },
  {
    id: 8,
    text: "Procurement Admin",
    path: "/approval-center",
    icon: (
      <ProfileIcon
        // _active={{ "> path": { fill: "white" } }}
        w={"30px"}
        h={"30px"}
      />
    ),
    visibleTo: ["ADMIN"],
  },
  {
    id: 9,
    text: "TC L2 Admin",
    path: "/tc-l2-admin",
    icon: (
      <ProfileIcon
        // _active={{ "> path": { fill: "white" } }}
        w={"30px"}
        h={"30px"}
      />
    ),
    visibleTo: ["ADMIN", "L2-TC-ISSUER"],
  },
  // {
  //   id: 10,
  //   text: "Shipment",
  //   path: "/shipments",
  //   icon: <ProfileIcon w={"30px"} h={"30px"} />,
  //   visibleTo: ["GINNER", "NONGINNER"],
  // },
  {
    id: 11,
    text: "Contracting",
    path: "/contractor",
    icon: <FaFileContract size={24} />,
    visibleTo: ["ADMIN", "CONTRACTOR"],
  },
  {
    id: 12,
    text: "Planning",
    path: "/planner",
    icon: <BsFillCalendar2WeekFill size={24} />,
    visibleTo: ["ADMIN", "PLANNER"],
  },
  {
    id: 13,
    text: "Auditing",
    path: "/auditor",
    icon: <AiOutlineAudit size={24} />,
    visibleTo: ["ADMIN", "AUDITOR"],
  },
  {
    id: 14,
    text: "Certification",
    path: "/certifier",
    icon: <GrCertificate size={24} />,
    visibleTo: ["ADMIN", "CERTIFIER"],
  },
  {
    id: 15,
    text: "User Creation",
    path: "/user-table",
    icon: <ProfileIcon w={"30px"} h={"30px"} />,
    visibleTo: ["ADMIN"],
  },
];

export const menu = (roles) => {
  return menuItems.filter((route) => {
    return roles.some((role) => route.visibleTo.includes(role));
  });
};

//Menu Items
export const tabMenu = [
  {
    id: 1,
    text: "Account",
    path: "/profile/account",
  },
  {
    id: 2,
    text: "My Documents",
    path: "/profile/my-documents",
  },
];

export { menuItems };

export const GOOGLE_API = `${process.env.REACT_APP_GOOGLE_API_KEY}`